import { Col } from "reactstrap";
import { dynamicImage } from "../../../Service/DynamicImage";
import { RegisterForm } from "../Common/RegisterForm";
import RatioImage from "../../../CommonElements/RatioImage";

const RegistrationWithImageTwoContainer = () => {
  return (
    <>
      <Col xl="7" className="p-0">
        <RatioImage className="bg-img-cover bg-center img-fluid w-100" src={dynamicImage("login/1.jpg")} alt="looginpage" />
      </Col>
      <div className="col-xl-5 p-0">
        <div className="login-card login-dark">
          <RegisterForm logoClass="text-start" />
        </div>
      </div>
    </>
  );
};

export default RegistrationWithImageTwoContainer;
